import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-zusatz',
    templateUrl: './input-field.component.html'
} )
export class AdressSupplementComponent extends AbstractFieldComponent<string> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.addressSupplement', );
    }

    set value( t: string | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.addressSupplement = t;
        }
    }

    get value(): string | undefined {
        return this.jobapplication?.addressSupplement;
    }
}
